export const overseaPlatMap = {
  "亚马逊美国": "amazon_us",
  "亚马逊日本": "amazon_jp",
  "亚马逊德国": "amazon_de",
  "亚马逊英国": "amazon_uk",
  "亚马逊法国": "amazon_fr",
  "亚马逊西班牙": "amazon_es",
  "亚马逊意大利": "amazon_it",
  "虾皮马来西亚": "shopee_my",
  "虾皮新加坡": "shopee_sg",
  "虾皮印尼": "shopee_id",
  "虾皮菲律宾": "shopee_ph",
  "虾皮泰国": "shopee_th",
  "虾皮越南": "shopee_vn",
  "虾皮台湾": "shopee_tw",
  "来赞达马来西亚": "lazada_my",
  "来赞达新加坡": "lazada_sg",
  "来赞达印尼": "lazada_id",
  "来赞达菲律宾": "lazada_ph",
  "来赞达泰国": "lazada_th",
  "来赞达越南": "lazada_vn"
}
